import React from "react";
import { Badge, Box, Grid, Text, VStack } from "@chakra-ui/react";
import { TransactionApiItem } from "store/userTransaction/userTransactionType";

function formatINR(n: number) {
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: n % 1 === 0 ? 0 : 2,
    }).format(n);
  } catch {
    return `₹${n}`;
  }
}

function statusColor(status: string) {
  const s = (status || "").toUpperCase();
  if (s === "SUCCESS") return "green";
  if (s === "ERROR" || s === "FAILED") return "red";
  if (s === "PENDING") return "yellow";
  return "gray";
}

// function formatDateTime(iso: string) {
//   const d = new Date(iso);
//   if (Number.isNaN(d.getTime())) return iso;
//   return d.toLocaleString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// }
function formatDateTime(iso: string) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;

  // Example: "21 Dec, 05:24 PM"
  const raw = d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  // Ensure am/pm uppercase if environment returns lowercase
  return raw.replace(/\b(am|pm)\b/i, (m) => m.toUpperCase());
}
export const TransactionRow: React.FC<{ tx: TransactionApiItem }> = ({
  tx,
}) => {
  // Your API doesn’t say credit/debit. For bill payments we assume debit display.
  const amountText = `${formatINR(Number(tx.amount || 0))}`;

  const primaryTitle =
    tx.status?.toUpperCase() === "SUCCESS"
      ? `Paid • {Biller Name}`
      : tx.status?.toUpperCase() === "PENDING"
        ? `Pending Payment • {Biller Name}`
        : //   tx.status?.toUpperCase() === "FAILED" ?
          `Failed Payment • {Biller Name}`;

  const comment =
    tx.message ||
    tx.responseReason ||
    (tx.responseCode ? `Response Code: ${tx.responseCode}` : "-");

  return (
    <Box px={3} py={3} borderBottomWidth="1px" borderColor="blackAlpha.100">
      <Grid templateColumns={{ base: "1fr", md: "2fr 1fr 1fr 2fr" }} gap={3}>
        {/* TRANSACTIONS column */}
        <VStack align="start" gap={0.5}>
          <Text fontWeight="medium" color="gray.800">
            {primaryTitle}
          </Text>

          {/* Time line (AM/PM uppercase) */}
          <Text fontSize="sm" color="gray.600">
            {formatDateTime(tx.createdAt)}
          </Text>

          <Box ml={2}>
            {/* Order ID under time (smaller) */}
            <Text fontSize="xs" color="gray.600">
              Order ID: {tx.orderId}
            </Text>

            {tx.transactionId && (
              <Text fontSize="xs" color="gray.600">
                Txn ID: {tx.transactionId}
              </Text>
            )}
          </Box>
        </VStack>

        {/* AMOUNT column */}
        <Box>
          <Text
            fontWeight="semibold"
            color="gray.800"
            // textAlign={{ base: "left", md: "right" }}
          >
            {amountText}
          </Text>
        </Box>

        {/* STATUS column */}
        <Box>
          <Badge colorScheme={statusColor(tx.status)} variant="plain">
            {(tx.status || "-").toUpperCase()}
          </Badge>
        </Box>

        {/* COMMENTS column */}
        <Box>
          <Text fontSize="sm" color="gray.700">
            {comment}
          </Text>
        </Box>
      </Grid>

      {/* Mobile-only extra rows (so it still looks good on small screens) */}
      {/* <Box display={{ base: "block", md: "none" }} mt={2}>
        <Grid templateColumns="1fr 1fr" gap={2}>
          <Box>
            <Box>
              <Badge colorScheme={statusColor(tx.status)} variant="plain">
                {(tx.status || "-").toUpperCase()}
              </Badge>
            </Box>
          </Box>

          <Box textAlign="right">
            <Text mt={1} fontWeight="semibold">
              {amountText}
            </Text>
          </Box>

          <Box gridColumn="1 / -1">
            <Text mt={1} fontSize="sm" color="gray.700">
              {comment}
            </Text>
          </Box>
        </Grid>
      </Box> */}
    </Box>
  );
};

export default TransactionRow;
